import React from 'react';
import useSetScrollRef from 'hooks/useSetScrollRef';
import HeroWrapper from 'shared/hero-wrapper';

import s from './hero.module.scss';

export default function HomeHero() {
  const hero = useSetScrollRef();
  return (
    <HeroWrapper img="cxn-hero-about" className={s.hero} ref={hero}>
      <img
        src="/svg/cxn-culture-growth.svg"
        alt="cxn-culture-growth"
        className={s.img}
      />
    </HeroWrapper>
  );
}
